/** The Roof Board mark in the app shell. The sign-in screen draws `Wordmark`. */
export const LOGO_DATA_URI = "/logo.png";

/**
 * The company's own mark, for documents that leave the building.
 *
 * Distinct from the wordmark above: that one is Roof Board, the tool, and
 * belongs on screens the staff use. This is CopperRidge Roofing & Exteriors
 * LLC, and belongs on the estimate, the work order and the material order a
 * customer or a supplier reads.
 *
 * The badge is a single copper on transparent, so it needs no light and dark
 * pair — unlike the wordmarks below.
 */
export const COMPANY_LOGO_URL = "/logo-copperridge.png";

/**
 * The full wordmark, in the two versions the artwork comes in.
 *
 * CopperRidge's lockup sets "RIDGE" and "ROOFING" in one flat colour and the
 * rest in copper, so there is no single file that works on both a white sheet
 * and the app's dark screens: whichever half is not copper disappears against
 * one of them, and what it disappears into is the company's own name.
 *
 * Named for the background each belongs on rather than for the colour of its
 * type, because that is the question anybody reaching for one is actually
 * asking. Both are drawn and CSS shows one — see `.loginlogo` in styles.css —
 * so the choice follows the same rules as every colour token, including the
 * `data-theme` override, rather than being a second opinion about the theme.
 */
export const WORDMARK_ON_LIGHT = "/logo-wordmark-on-light.png";
export const WORDMARK_ON_DARK = "/logo-wordmark-on-dark.png";
